import { render } from "./ConfigurationMenuItem.vue?vue&type=template&id=fc7daa66"
import script from "./ConfigurationMenuItem.vue?vue&type=script&lang=js"
export * from "./ConfigurationMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ConfigurationMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc7daa66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc7daa66', __exports__)) {
    console.log('reload')
    api.reload('fc7daa66', __exports__)
  }
  
  module.hot.accept("./ConfigurationMenuItem.vue?vue&type=template&id=fc7daa66", () => {
    console.log('re-render')
    api.rerender('fc7daa66', render)
  })

}


export default __exports__